import { render, staticRenderFns } from "./PaginaSimples.vue?vue&type=template&id=10982a61"
import script from "./PaginaSimples.vue?vue&type=script&lang=js"
export * from "./PaginaSimples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports